@if (game.currentLeague()?.type === 'PRIVATE') {
  <p class="text-xs text-slate-500 dark:text-slate-400 mb-3">Sin divisiones. PJ incluye derrotas administrativas; los descansos no son partidos.</p>
}
<div class="space-y-6" [class.pb-20]="!embedded()" [class.sm:pb-8]="!embedded()">
  @if (!embedded()) {
  <!-- Top Header (Material Surface) -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 bg-white dark:bg-slate-900 p-5 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md transition-colors">
    <div>
      <div class="flex items-center space-x-2">
        <h2 class="text-xl font-bold text-slate-900 dark:text-white">{{ game.t('comp.title') }}</h2>       
      </div>
      <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
        {{ game.t('comp.league_desc') }}
      </p>
    </div>

    <!-- Current Round Status Pill -->
    <div class="flex items-center space-x-2 bg-slate-50 dark:bg-slate-950 px-3.5 py-2 rounded-xl border border-slate-200 dark:border-slate-800 text-xs">
      <app-icon name="calendar" [size]="16" class="text-emerald-600 dark:text-emerald-400" />
      <span class="text-slate-700 dark:text-slate-300 font-medium">
        {{ game.t('comp.current_round') }} <strong class="text-slate-900 dark:text-white font-mono">{{ currentMatchdayNumber() }} / {{ game.matchdays().length }}</strong>
      </span>
      <span class="px-2 py-0.5 rounded-lg text-[10px] font-bold bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-950 dark:text-emerald-400 dark:border-emerald-800">
        {{ game.t('comp.in_progress') }}
      </span>
    </div>
  </div>

  }

  <!-- Grid: Standings Table (Left/Top) + Fixture Calendar (Right) -->
  <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">
    @if (showStandings()) {
    <!-- League Standings Table (7 cols on large screens) -->
    <div [class.lg:col-span-7]="showCalendar()" [class.lg:col-span-12]="!showCalendar()" class="min-w-0 flex flex-col justify-between transition-colors" [ngClass]="standingsInCard() ? '' : 'bg-white dark:bg-slate-900 rounded-xl sm:rounded-2xl border border-slate-200 dark:border-slate-800 p-2 sm:p-5 shadow-xs'">
      <div>
        @if (!standingsInCard()) {
        <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3 mb-3">
          <div class="flex items-center space-x-2">
            <app-icon name="trophy" [size]="16" class="text-amber-500" />
            <h3 class="text-sm font-bold text-slate-900 dark:text-white uppercase tracking-wider">
              {{ game.t('comp.live_standings') }}
            </h3>
          </div>
          <div class="flex items-center space-x-2">
            <span class="text-[11px] text-slate-500 dark:text-slate-400 hidden md:inline">{{ game.t('comp.tiebreaker_legend') }}</span>
            <button
              (click)="refreshStandings()"
              [disabled]="effectiveStandingsLoading()"
              class="p-1 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors cursor-pointer disabled:opacity-40"
              [title]="game.t('comp.refresh_standings')"
            >
              <app-icon name="refresh-cw" [size]="14" [class.animate-spin]="effectiveStandingsLoading()" />
            </button>
          </div>
        </div>

        }

        @if (effectiveStandingsError()) {
          <div class="mb-3 px-3 py-2 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 dark:bg-amber-950/30 dark:border-amber-800/40 dark:text-amber-300 text-xs flex items-center justify-between">
            <span class="truncate">{{ effectiveStandingsError() }}</span>
            <button (click)="refreshStandings()" class="underline font-medium text-xs ml-2 shrink-0 cursor-pointer">{{ game.t('common.retry') }}</button>
          </div>
        }

        <!-- Table Container -->
        <div class="standings-table-container overflow-x-auto rounded-xl sm:border border-slate-200 dark:border-slate-800 relative">
          @if (effectiveStandingsLoading() && standings().length === 0) {
            <div class="py-16 text-center text-slate-400 text-xs flex flex-col items-center justify-center space-y-3">
              <span class="animate-spin text-emerald-600 dark:text-emerald-400 text-lg">⏳</span>
              <span class="font-medium text-slate-600 dark:text-slate-300">{{ game.t('comp.loading_standings') }}</span>
            </div>
          } @else {
            <table class="standings-table w-full text-left text-xs" [class.opacity-40]="effectiveStandingsLoading()">
              <thead class="bg-slate-50 dark:bg-slate-950/70 border-b border-slate-200 dark:border-slate-800">
                <tr class="text-slate-600 dark:text-slate-400 font-bold uppercase text-[9px] sm:text-[10px]">
                  <th class="py-2 sm:py-2.5 px-1 sm:px-2 text-center w-6 sm:w-8">#</th>
                  <th class="py-2 sm:py-2.5 px-1 sm:px-2">{{ game.t('comp.club_col') }}</th>
                  <th class="py-2 sm:py-2.5 px-1 sm:px-2 text-center font-bold text-slate-900 dark:text-white">Pts</th>
                  <th class="py-2 sm:py-2.5 px-0.5 sm:px-1.5 text-center">PJ</th>                  
                  <th class="py-2 sm:py-2.5 px-0.5 sm:px-1.5 text-center">PG</th>
                  <th class="py-2 sm:py-2.5 px-0.5 sm:px-1.5 text-center">PE</th>
                  <th class="py-2 sm:py-2.5 px-0.5 sm:px-1.5 text-center">PP</th>
                  <th class="py-2 sm:py-2.5 px-0.5 sm:px-1.5 text-center">DG</th>
                  <th class="py-2 sm:py-2.5 px-1.5 text-center hidden sm:table-cell">GF</th>
                  <th class="py-2 sm:py-2.5 px-1.5 text-center hidden sm:table-cell">GC</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-100 dark:divide-slate-800/60 font-medium">
                @for (row of standings(); track row.clubId; let index = $index) {
                  <tr
                    class="transition-colors"
                    [ngClass]="[
                      getRowBackgroundClass(row, index),
                      getTierBorderClass(index)
                    ]"
                  >
                    <td class="py-1.5 sm:py-2 px-1 sm:px-2 text-center font-mono text-[11px] sm:text-xs" [ngClass]="getTierTextClass(index)">
                      {{ row.position || (index + 1) }}
                    </td>
                    <td class="py-1.5 sm:py-2 px-1 sm:px-2">
                      <button
                        type="button"
                        (click)="openClubProfile(row.clubId, row.clubName, row.clubCode)"
                        class="flex items-center space-x-1 sm:space-x-2 text-left group cursor-pointer focus:outline-none"
                        [title]="'Ver ficha de ' + row.clubName"
                      >
                        <div class="w-4 h-5 sm:w-5 sm:h-6 flex items-center justify-center shrink-0 transition-transform group-hover:scale-105">
                          <app-club-shield
                            [club]="getClubForRow(row)"
                            [fallbackText]="row.clubCode"
                            [fallbackBgColor]="getClubColor(row)"
                            size="sm"
                          />
                        </div>
                        <span class="truncate max-w-[80px] xs:max-w-[110px] sm:max-w-[130px] group-hover:underline group-hover:text-emerald-700 dark:group-hover:text-emerald-400 font-semibold text-[11px] sm:text-xs">{{ row.clubName }}</span>
                        @if (isUserClub(row)) {
                          <span class="text-[8px] sm:text-[9px] bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-400 px-1 sm:px-1.5 py-0.5 rounded font-bold shrink-0">{{ game.t('comp.you_badge') }}</span>
                        }
                      </button>
                    </td>
                    <td class="py-1.5 sm:py-2 px-1 sm:px-2 text-center font-bold text-slate-900 dark:text-white font-mono text-xs sm:text-sm">
                      {{ row.points }}
                    </td>
                    <td class="py-1.5 sm:py-2 px-0.5 sm:px-1.5 text-center font-mono text-[10px] sm:text-xs text-slate-500 dark:text-slate-400" [attr.title]="row.administrativeLosses !== undefined ? 'Deportivos: ' + row.sportingMatchesPlayed + ' · Derrotas administrativas: ' + row.administrativeLosses + ' · Descansos: ' + row.byes : null">{{ row.played }}</td>
                    <td class="py-1.5 sm:py-2 px-0.5 sm:px-1.5 text-center font-mono text-[10px] sm:text-xs text-slate-500 dark:text-slate-400">{{ row.won }}</td>
                    <td class="py-1.5 sm:py-2 px-0.5 sm:px-1.5 text-center font-mono text-[10px] sm:text-xs text-slate-500 dark:text-slate-400">{{ row.drawn }}</td>
                    <td class="py-1.5 sm:py-2 px-0.5 sm:px-1.5 text-center font-mono text-[10px] sm:text-xs text-slate-500 dark:text-slate-400">{{ row.lost }}</td>
                    <td class="py-1.5 sm:py-2 px-1.5 text-center font-mono text-[10px] sm:text-xs text-slate-400 dark:text-slate-500 hidden sm:table-cell">{{ row.goalsFor }}</td>
                    <td class="py-1.5 sm:py-2 px-1.5 text-center font-mono text-[10px] sm:text-xs text-slate-400 dark:text-slate-500 hidden sm:table-cell">{{ row.goalsAgainst }}</td>
                    <td class="py-1.5 sm:py-2 px-0.5 sm:px-1.5 text-center font-mono text-[10px] sm:text-xs" [ngClass]="row.goalDifference > 0 ? 'text-emerald-700 dark:text-emerald-400 font-semibold' : row.goalDifference < 0 ? 'text-rose-600 dark:text-rose-400 font-semibold' : 'text-slate-500 dark:text-slate-400'">
                      {{ row.goalDifference > 0 ? '+' + row.goalDifference : row.goalDifference }}
                    </td>
                    
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>

        <!-- Legend -->
        <div class="flex flex-wrap items-center gap-2 sm:gap-4 mt-3 sm:mt-4 pt-2.5 sm:pt-3 border-t border-slate-100 dark:border-slate-800 text-[10px] sm:text-[11px] text-slate-500 dark:text-slate-400 px-1 sm:px-0">
          @if (standings().length <= 8) {
            <span class="flex items-center space-x-1.5">
              <span class="w-2.5 h-2.5 rounded-full bg-blue-500"></span>
              <span>1-2º {{ game.t('comp.legend_playoff') }}</span>
            </span>
            @if (standings().length >= 5) {
              <span class="flex items-center space-x-1.5">
                <span class="w-2.5 h-2.5 rounded-full bg-rose-500"></span>
                <span>{{ standings().length - 1 }}-{{ standings().length }}º {{ game.t('comp.legend_relegation') }}</span>
              </span>
            }
          } @else {
            <!--<span class="flex items-center space-x-1.5">
              <span class="w-2.5 h-2.5 rounded-full bg-blue-500"></span>
              <span>1-4º {{ game.t('comp.legend_champions') }}</span>
            </span>
            <span class="flex items-center space-x-1.5">
              <span class="w-2.5 h-2.5 rounded-full bg-amber-500"></span>
              <span>5-6º {{ game.t('comp.legend_europa') }}</span>
            </span>
            <span class="flex items-center space-x-1.5">
              <span class="w-2.5 h-2.5 rounded-full bg-emerald-500"></span>
              <span>7º {{ game.t('comp.legend_conference') }}</span>
            </span>
            <span class="flex items-center space-x-1.5">
              <span class="w-2.5 h-2.5 rounded-full bg-rose-500"></span>
              <span>17-20º {{ game.t('comp.legend_relegation') }}</span>
            </span>-->
          }
        </div>
      </div>
    </div>

    }
    <!-- Fixture Calendar (5 cols on large screens) -->
    <div [class.hidden]="!showCalendar()" [class.lg:col-span-5]="showStandings()" [class.lg:col-span-12]="!showStandings()" class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-4 sm:p-5 flex flex-col justify-between shadow-xs space-y-4 transition-colors">
      <div>
        <!-- Round Selector Header -->
        <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
          <button
            (click)="prevMatchday()"
            [disabled]="!canGoPrev() || isLoadingCalendar()"
            class="p-1.5 text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white disabled:opacity-30 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
            [title]="game.t('comp.prev_round')"
          >
            <app-icon name="chevron-left" [size]="18" />
          </button>

          <div class="text-center">
            <div class="flex items-center justify-center space-x-1.5">
              <h3 class="text-sm font-bold text-slate-900 dark:text-white">
                @if (currentMatchdayNumber() !== null) {
                  {{ game.t('comp.round_prefix') }} {{ currentMatchdayNumber() }} {{ game.t('comp.round_of') }} {{ totalMatchdays() || 38 }}
                } @else {
                  {{ game.t('comp.loading_round') }}
                }
              </h3>
              @if (isLoadingCalendar()) {
                <span class="animate-spin text-xs text-slate-400">⏳</span>
              }
            </div>
            <div class="flex items-center justify-center space-x-2 text-[10px] text-slate-500 dark:text-slate-400 mt-0.5">
              @if (calendarResponse()) {
                <span>{{ matchdayStatusText() }}</span>
                <!--@if (calendarResponse()?.groupName) {
                  <span>•</span>
                  <span class="truncate max-w-[130px]" [title]="calendarResponse()?.groupName">{{ calendarResponse()?.groupName }}</span>
              }-->
              } @else {
                <span>{{ game.t('comp.official_calendar') }}</span>
              }
            </div>
          </div>

          <button
            (click)="nextMatchdayNav()"
            [disabled]="!canGoNext() || isLoadingCalendar()"
            class="p-1.5 text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white disabled:opacity-30 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer transition-colors"
            [title]="game.t('comp.next_round')"
          >
            <app-icon name="chevron-right" [size]="18" />
          </button>
        </div>

        @if (calendarError()) {
          <div class="mt-2.5 px-3 py-2 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 dark:bg-amber-950/30 dark:border-amber-800/40 dark:text-amber-300 text-xs flex items-center justify-between">
            <span class="truncate">{{ calendarError() }}</span>
            <button (click)="refreshCalendar()" class="underline font-medium text-xs ml-2 shrink-0 cursor-pointer">{{ game.t('common.retry') }}</button>
          </div>
        }

        <!-- List of fixtures for selected matchday -->
        <div class="space-y-2 mt-3 max-h-[520px] overflow-y-auto pr-1 relative">
          @if (isLoadingCalendar() && !calendarResponse()) {
            <div class="py-16 text-center text-slate-400 text-xs flex flex-col items-center justify-center space-y-3">
              <span class="animate-spin text-emerald-600 dark:text-emerald-400 text-lg">⏳</span>
              <span class="font-medium text-slate-600 dark:text-slate-300">{{ game.t('comp.loading_fixtures') }}</span>
            </div>
          } @else {
            <div [class.opacity-40]="isLoadingCalendar()" [class.pointer-events-none]="isLoadingCalendar()" class="space-y-2 transition-opacity duration-200">
              @for (fixture of fixtures(); track fixture.id) {
                <div
                  (click)="inspectFixture(fixture)"
                  class="p-3 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 hover:border-slate-300 dark:hover:border-slate-700 transition-all cursor-pointer grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 shadow-xs"
                  [ngClass]="isUserFixture(fixture) ? 'border-emerald-300 bg-emerald-50/70 dark:border-emerald-500/50 dark:bg-emerald-950/20' : ''"
                >
                  <!-- Home -->
                  <div class="flex items-center space-x-2 min-w-0 overflow-hidden">
                    <button
                      type="button"
                      (click)="$event.stopPropagation(); openClubProfile(fixture.homeClubId, fixture.homeClubName, fixture.homeClubCode)"
                      class="flex items-center space-x-2 min-w-0 truncate text-left group cursor-pointer"
                      [title]="'Ver ficha de ' + fixture.homeClubName"
                    >
                      <div class="w-4 h-5 flex items-center justify-center shrink-0 transition-transform group-hover:scale-105">
                        <app-club-shield
                          [club]="getClubForFixture(fixture.homeClubId, fixture.homeClubName, fixture.homeClubCode)"
                          size="xs"
                        />
                      </div>
                      <span class="text-xs font-semibold text-slate-800 dark:text-slate-200 truncate group-hover:underline group-hover:text-emerald-700 dark:group-hover:text-emerald-400">
                        {{ fixture.homeClubName }}
                      </span>
                    </button>
                  </div>

                  <!-- Score / VS / Status -->
                  <div class="text-center whitespace-nowrap">
                    @if (fixture.played && fixture.homeScore !== undefined && fixture.awayScore !== undefined) {
                      <span class="inline-flex items-center whitespace-nowrap px-2 py-0.5 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white font-mono font-bold text-xs border border-slate-200 dark:border-slate-700 shadow-xs">
                        {{ fixture.homeScore }} - {{ fixture.awayScore }}
                      </span>
                    } @else {
                      <span class="text-[11px] font-mono text-slate-400 dark:text-slate-500 font-semibold px-2 py-0.5">VS</span>
                    }
                  </div>

                  <!-- Away -->
                  <div class="flex items-center justify-end space-x-2 min-w-0 overflow-hidden text-right">
                    <button
                      type="button"
                      (click)="$event.stopPropagation(); openClubProfile(fixture.awayClubId, fixture.awayClubName, fixture.awayClubCode)"
                      class="flex items-center justify-end space-x-2 min-w-0 truncate text-right group cursor-pointer ml-auto"
                      [title]="'Ver ficha de ' + fixture.awayClubName"
                    >
                      <span class="text-xs font-semibold text-slate-800 dark:text-slate-200 truncate group-hover:underline group-hover:text-emerald-700 dark:group-hover:text-emerald-400">
                        {{ fixture.awayClubName }}
                      </span>
                      <div class="w-4 h-5 flex items-center justify-center shrink-0 transition-transform group-hover:scale-105">
                        <app-club-shield
                          [club]="getClubForFixture(fixture.awayClubId, fixture.awayClubName, fixture.awayClubCode)"
                          size="xs"
                        />
                      </div>
                    </button>
                  </div>
                </div>
              } @empty {
                @if (restingClubs().length === 0) {
                <div class="py-8 text-center text-slate-400 text-xs">
                  {{ game.t('comp.no_fixtures') }}
                </div>
                }
              }
              @for (club of restingClubs(); track club.id) {
                <div role="status"
                  class="p-3 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 flex items-center justify-between gap-3 shadow-xs"
                  [ngClass]="club.id === (activeClubId() || game.activeUserClubId()) ? 'border-emerald-300 bg-emerald-50/70 dark:border-emerald-500/50 dark:bg-emerald-950/20' : ''">
                  <button type="button" (click)="openClubProfile(club.id, club.name, getBadgeCode(club))"
                    class="flex items-center space-x-2 min-w-0 text-left group cursor-pointer" [title]="'Ver ficha de ' + club.name">
                    <div class="w-4 h-5 flex items-center justify-center shrink-0">
                      <app-club-shield
                        [club]="getClubForFixture(club.id, club.name, getBadgeCode(club))"
                        size="xs"
                      />
                    </div>
                    <span class="text-xs font-semibold text-slate-800 dark:text-slate-200 truncate group-hover:underline">{{ club.name }}</span>
                  </button>
                  <span class="shrink-0 px-2 py-0.5 rounded-lg bg-slate-100 dark:bg-slate-800 text-xs font-semibold text-slate-600 dark:text-slate-300">Descansa</span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Fixture Details Modal (visualiza alineaciones y puntuaciones desde /api/matches/:fixtureId/live) -->
  @if (inspectedFixture()) {
    <div
      (click)="closeInspectModal()"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-xs p-3 sm:p-4 overflow-y-auto cursor-pointer"
    >
      <div
        (click)="$event.stopPropagation()"
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl max-w-4xl w-full max-h-[92vh] flex flex-col shadow-2xl cursor-default overflow-hidden my-auto"
      >
        <!-- Modal Header -->
        <div class="flex items-center justify-between p-4 sm:p-5 border-b border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-950/50 shrink-0">
          <div class="flex items-center space-x-3">
            <div class="p-2 rounded-xl bg-emerald-50 dark:bg-emerald-950/50 text-emerald-600 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800/60">
              <app-icon name="shield" [size]="18" />
            </div>
            <div>
              <div class="flex items-center space-x-2">
                <h3 class="text-base font-bold text-slate-900 dark:text-white">
                  {{ game.t('comp.match_detail_title') }}
                </h3>
                <span
                  class="px-2.5 py-0.5 rounded-full text-[11px] font-semibold flex items-center space-x-1"
                  [ngClass]="getLiveStatusBadge().class"
                >
                  <app-icon [name]="getLiveStatusBadge().icon" [size]="12" />
                  <span>{{ getLiveStatusBadge().label }}</span>
                </span>
              </div>
              <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                {{ game.t('comp.round_prefix') }} {{ currentMatchdayNumber() || selectedMatchdayNumber }} • Calendario oficial
              </p>
            </div>
          </div>

          <button
            type="button"
            (click)="closeInspectModal()"
            class="p-1.5 rounded-xl text-slate-400 hover:text-slate-700 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer"
            title="Cerrar (ESC)"
          >
            <app-icon name="x" [size]="18" />
          </button>
        </div>

        <!-- Scrollable Modal Body -->
        <div class="p-1 sm:p-6 overflow-y-auto space-y-5 flex-1">
          <!-- Scoreboard Header Card -->
          <div class="p-4 sm:p-5 bg-slate-50 dark:bg-slate-950 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs">
            @if (inspectedFixture()?.phase?.toUpperCase() === 'PLAYOFF') {
              <div class="mb-3.5 px-3 py-1.5 rounded-xl bg-gradient-to-r from-amber-500/15 via-yellow-500/15 to-amber-500/15 border border-amber-500/30 text-amber-800 dark:text-amber-300 text-xs font-bold flex items-center justify-between shadow-2xs">
                <div class="flex items-center space-x-1.5">
                  <app-icon name="trophy" [size]="14" class="text-amber-500" />
                  <span class="uppercase tracking-wider font-extrabold">
                    Playoff{{ inspectedFixture()?.playoffType ? ' (' + inspectedFixture()!.playoffType + ')' : '' }}
                  </span>
                  @if (inspectedFixture()?.cycleNumber) {
                    <span class="text-[10px] text-amber-700 dark:text-amber-300 font-mono font-semibold">
                      • Ciclo {{ inspectedFixture()!.cycleNumber }}
                    </span>
                  }
                </div>
                <span class="text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full bg-amber-500 text-slate-950 shadow-2xs">
                  Eliminatoria
                </span>
              </div>
            }
            <div class="flex items-center justify-between gap-2 sm:gap-4">
              <!-- Home Team -->
              <div class="flex-1 flex items-center space-x-2 sm:space-x-3 min-w-0">
                <app-club-shield
                  [clubId]="inspectedFixture()!.homeClubId"
                  [clubName]="inspectedFixture()!.homeClubName"
                  [clubCode]="inspectedFixture()!.homeClubCode"
                  [shield]="inspectedFixture()!.homeClubId === game.userClub()?.id ? game.userClub()?.shield : null"
                  size="md"
                  customClass="shrink-0"
                />
                <div class="min-w-0">
                  <span class="block text-xs sm:text-sm font-bold text-slate-900 dark:text-white truncate" [title]="inspectedFixture()!.homeClubName">
                    {{ inspectedFixture()!.homeClubName }}
                  </span>
                  <span class="text-[11px] text-slate-500 dark:text-slate-400 font-medium">Local</span>
                </div>
              </div>

              <!-- Score / Status in the center -->
              <div class="shrink-0 text-center flex flex-col items-center justify-center px-2">
                @if (matchLive()?.status === 'WAITING_FOR_POINTS' || (!matchLive() && (inspectedFixture()?.status === 'PLANNED' || isLiveNotAvailable() || (getLiveScoreDisplay().home === '-' && getLiveScoreDisplay().away === '-')))) {
                  <div class="px-3.5 py-1.5 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs">
                    <span class="text-xs sm:text-sm font-bold text-slate-500 dark:text-slate-400 tracking-wider">
                      VS
                    </span>
                  </div>
                } @else {
                  <div class="px-3.5 py-1.5 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs">
                    <span class="text-xl sm:text-2xl font-mono font-bold text-slate-900 dark:text-white tracking-tight">
                      {{ getLiveScoreDisplay().home }} - {{ getLiveScoreDisplay().away }}
                    </span>
                  </div>
                }
              </div>

              <!-- Away Team -->
              <div class="flex-1 flex items-center justify-end space-x-2 sm:space-x-3 min-w-0 text-right">
                <div class="min-w-0">
                  <span class="block text-xs sm:text-sm font-bold text-slate-900 dark:text-white truncate" [title]="inspectedFixture()!.awayClubName">
                    {{ inspectedFixture()!.awayClubName }}
                  </span>
                  <span class="text-[11px] text-slate-500 dark:text-slate-400 font-medium">Visitante</span>
                </div>
                <app-club-shield
                  [clubId]="inspectedFixture()!.awayClubId"
                  [clubName]="inspectedFixture()!.awayClubName"
                  [clubCode]="inspectedFixture()!.awayClubCode"
                  [shield]="inspectedFixture()!.awayClubId === game.userClub()?.id ? game.userClub()?.shield : null"
                  size="md"
                  customClass="shrink-0"
                />
              </div>
            </div>

            <!-- Provisional dominance from accumulated player points -->
            @if (matchLive()?.status === 'WAITING_FOR_POINTS') {
              @let trend = getMatchTrend();
              <div class="mt-4 pt-3.5 border-t border-slate-200/60 dark:border-slate-800/80 space-y-2.5">
                <div class="flex items-center justify-between text-xs sm:text-sm">
                  <div class="flex items-center space-x-1.5 sm:space-x-2 shrink-0">
                    <span class="font-mono font-bold text-emerald-500 dark:text-emerald-400">
                      {{ trend.homePower }}%
                    </span>
                    <span
                      class="text-[10px] sm:text-[11px] font-mono font-semibold text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/60 px-1.5 py-0.5 rounded border border-emerald-200/60 dark:border-emerald-800/60"
                      [title]="'Jugadores locales puntuados: ' + trend.homeScoredPlayers + '/' + trend.homeTotalPlayers"
                    >
                      {{ trend.homeScoredPlayers }}/{{ trend.homeTotalPlayers }}
                    </span>
                  </div>
                  <span class="text-xs sm:text-sm font-medium text-slate-700 dark:text-slate-200 text-center truncate px-2">
                    Dominio del partido
                  </span>
                  <div class="flex items-center space-x-1.5 sm:space-x-2 shrink-0 justify-end">
                    <span
                      class="text-[10px] sm:text-[11px] font-mono font-semibold text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/60 px-1.5 py-0.5 rounded border border-amber-200/60 dark:border-amber-800/60"
                      [title]="'Jugadores visitantes puntuados: ' + trend.awayScoredPlayers + '/' + trend.awayTotalPlayers"
                    >
                      {{ trend.awayScoredPlayers }}/{{ trend.awayTotalPlayers }}
                    </span>
                    <span class="font-mono font-bold text-amber-500 dark:text-amber-400">
                      {{ trend.awayPower }}%
                    </span>
                  </div>
                </div>
                <div
                  class="w-full h-3.5 sm:h-4 rounded-full overflow-hidden flex bg-slate-200 dark:bg-slate-800 shadow-inner"
                  [title]="'Dominio provisional (puntos acumulados): ' + trend.homePower + '% (' + trend.homePoints.toFixed(2) + ' puntos) - ' + trend.awayPower + '% (' + trend.awayPoints.toFixed(2) + ' puntos)'"
                >
                  <div class="h-full bg-emerald-500 transition-all duration-500" [style.width.%]="trend.homePower"></div>
                  <div class="h-full bg-amber-500 transition-all duration-500" [style.width.%]="trend.awayPower"></div>
                </div>
              </div>
            }

            <!-- Match stats sub-bar -->
            @if (matchLive()) {
              <div class="mt-4 pt-3 border-t border-slate-200/60 dark:border-slate-800/80 flex flex-wrap items-center justify-between gap-2 text-[11px] text-slate-500 dark:text-slate-400">
                <div class="flex items-center space-x-1.5">
                    <app-icon name="users" [size]="13" class="text-slate-400 dark:text-slate-500 shrink-0" />
                    <span>Aforo: {{ formatAttendancePercent(matchLive()?.attendancePercent) }}</span>
                  </div>
                  <div class="flex items-center space-x-1 font-mono text-[10px] sm:text-[11px] text-slate-400 dark:text-slate-500">
                    <app-icon name="refresh-cw" [size]="11" class="shrink-0" />
                    <span>{{ getMatchUpdateTime() }}</span>
                  </div>
                
              </div>
            }
          </div>

          <!-- Aviso de sincronización Live tras guardar sustituciones -->
          @if (syncingLiveMessage()) {
            <div class="p-3 rounded-xl bg-blue-50 dark:bg-blue-950/60 border border-blue-200 dark:border-blue-800 text-blue-800 dark:text-blue-300 text-xs font-semibold flex items-center space-x-2 animate-pulse">
              <app-icon name="loader" [size]="14" class="animate-spin text-blue-600 dark:text-blue-400 shrink-0" />
              <span>{{ syncingLiveMessage() }}</span>
            </div>
          }

          <!-- Selector de Vista: Partido en Directo vs Sustituciones vs Detalles -->
          <div class="flex items-center justify-between gap-2 border-b border-slate-200 dark:border-slate-800 pb-3">
            <div class="flex items-center space-x-1.5 p-1 bg-slate-100 dark:bg-slate-950 rounded-xl border border-slate-200/80 dark:border-slate-800">
              <button
                type="button"
                (click)="activeModalView.set('live')"
                class="px-3.5 py-1.5 rounded-lg text-xs font-bold transition-all cursor-pointer flex items-center space-x-1.5"
                [ngClass]="activeModalView() === 'live' ? 'bg-white dark:bg-slate-900 text-slate-900 dark:text-white shadow-xs' : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white'"
              >
                <app-icon name="activity" [size]="14" />
                <span>En Directo</span>
              </button>
              @if (isUserClubFixture()) {
                <button
                  type="button"
                  (click)="activeModalView.set('substitutions')"
                  class="px-3.5 py-1.5 rounded-lg text-xs font-bold transition-all cursor-pointer flex items-center space-x-1.5 relative"
                  [ngClass]="activeModalView() === 'substitutions' ? 'bg-white dark:bg-slate-900 text-emerald-600 dark:text-emerald-400 shadow-xs' : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white'"
                >
                  <app-icon name="repeat" [size]="14" />
                  <span>Sustituciones</span>
                  @if (pendingChanges().length > 0) {
                    <span class="px-1.5 py-0.2 rounded-full text-[10px] bg-emerald-600 text-white font-mono">
                      {{ pendingChanges().length }}
                    </span>
                  }
                </button>
              }
              <button
                type="button"
                (click)="activeModalView.set('details')"
                class="px-3.5 py-1.5 rounded-lg text-xs font-bold transition-all cursor-pointer flex items-center space-x-1.5"
                [ngClass]="activeModalView() === 'details' ? 'bg-white dark:bg-slate-900 text-emerald-600 dark:text-emerald-400 shadow-xs' : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white'"
              >
                <app-icon name="trending-up" [size]="14" />
                <span>Detalles</span>
              </button>
            </div>

            @if (activeModalView() === 'substitutions') {
              <button
                type="button"
                (click)="loadTacticalLineup()"
                [disabled]="isLoadingTactical()"
                class="px-2.5 py-1.5 text-xs font-medium text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-white rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors flex items-center space-x-1 cursor-pointer"
              >
                <app-icon name="refresh-cw" [size]="13" [class]="isLoadingTactical() ? 'animate-spin' : ''" />
                <span>Actualizar</span>
              </button>
            }
          </div>

          @if (activeModalView() === 'substitutions') {
            <!-- VISTA DE SUSTITUCIONES TÁCTICAS -->
            <div class="space-y-4 animate-in fade-in duration-150">
              @if (isLoadingTactical() && !tacticalLineup()) {
                <div class="py-12 text-center text-slate-400 text-xs">
                  <app-icon name="loader" [size]="22" class="animate-spin mx-auto mb-2 text-emerald-500" />
                  <p class="font-medium">Cargando convocatoria y opciones tácticas...</p>
                </div>
              } @else if (tacticalError() && isTacticalNotAvailable()) {
                <!-- 404 No hay captura deportiva o descanso -->
                <div class="p-6 rounded-2xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-center space-y-2">
                  <div class="w-12 h-12 mx-auto rounded-xl bg-amber-500/10 text-amber-500 flex items-center justify-center">
                    <app-icon name="alert-circle" [size]="22" />
                  </div>
                  <h4 class="text-sm font-bold text-slate-900 dark:text-white">Captura no disponible</h4>
                  <p class="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto">
                    {{ tacticalError() }}
                  </p>
                </div>
              } @else if (tacticalError()) {
                <div class="p-4 rounded-xl bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900 text-rose-800 dark:text-rose-300 text-xs flex items-center justify-between">
                  <div class="flex items-center space-x-2">
                    <app-icon name="alert-circle" [size]="16" class="shrink-0" />
                    <span>{{ tacticalError() }}</span>
                  </div>
                  <button type="button" (click)="loadTacticalLineup()" class="px-3 py-1 bg-rose-600 text-white rounded-lg text-xs font-semibold cursor-pointer">Reintentar</button>
                </div>
              } @else if (tacticalLineup(); as tl) {
                <!-- Tarjetas resumen de recursos -->
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-2.5">
                  <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-center">
                    <div class="text-[10px] uppercase font-bold text-slate-400">Ventanas restantes</div>
                    <div class="text-lg font-mono font-bold text-emerald-600 dark:text-emerald-400 mt-0.5">
                      {{ tl.windowsRemaining }} <span class="text-xs text-slate-400 font-normal">/ 3</span>
                    </div>
                  </div>
                  <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-center">
                    <div class="text-[10px] uppercase font-bold text-slate-400">Sustituciones restantes</div>
                    <div class="text-lg font-mono font-bold text-emerald-600 dark:text-emerald-400 mt-0.5">
                      {{ tl.substitutionsRemaining }} <span class="text-xs text-slate-400 font-normal">/ 5</span>
                    </div>
                  </div>
                  <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-center">
                    <div class="text-[10px] uppercase font-bold text-slate-400">Ventanas usadas</div>
                    <div class="text-lg font-mono font-bold text-slate-700 dark:text-slate-300 mt-0.5">
                      {{ tl.lineup?.windowsUsed ?? 0 }}
                    </div>
                  </div>
                  <div class="p-3 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-center">
                    <div class="text-[10px] uppercase font-bold text-slate-400">Revisión táctica</div>
                    <div class="text-lg font-mono font-bold text-blue-600 dark:text-blue-400 mt-0.5">
                      Rev. {{ tl.lineup?.revision ?? 0 }}
                    </div>
                  </div>
                </div>

                <!-- Preparador del lote si quedan recursos -->
                @if (tl.windowsRemaining > 0 && tl.substitutionsRemaining > 0) {
                  <div class="grid grid-cols-1 lg:grid-cols-12 gap-5 items-start">
                    
                    <!-- COLUMNA IZQUIERDA: CAMPO TÁCTICO CON LA FORMACIÓN -->
                    <div class="lg:col-span-7 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-4 space-y-3 shadow-xs">
                      <div class="flex items-center justify-between pb-2 border-b border-slate-100 dark:border-slate-800">
                        <div class="flex items-center space-x-2">
                          <span class="p-1.5 rounded-lg bg-emerald-500/10 text-emerald-600 dark:text-emerald-400">
                            <app-icon name="users" [size]="15" />
                          </span>
                          <div>
                            <h4 class="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-white">
                              Once en el campo ({{ tl.lineup?.formation || '4-4-2' }})
                            </h4>
                            <p class="text-[11px] text-slate-500 dark:text-slate-400">
                              Pulsa sobre un jugador para seleccionarlo como titular saliente
                            </p>
                          </div>
                        </div>

                        @if (selectedOutgoing()) {
                          <button
                            type="button"
                            (click)="selectedOutgoing.set(null)"
                            class="text-[11px] text-slate-400 hover:text-rose-500 cursor-pointer font-medium"
                          >
                            Deseleccionar
                          </button>
                        }
                      </div>

                      <!-- Campo de fútbol idéntico al de plantilla -->
                      <div class="relative w-full aspect-[3/4] max-w-md mx-auto bg-emerald-950/90 dark:bg-[#0c131a] rounded-2xl border border-emerald-800/40 dark:border-white/10 overflow-hidden select-none shadow-inner p-2 sm:p-3">
                        <!-- Líneas del campo -->
                        <div class="absolute inset-2 border border-white/20 rounded-xl pointer-events-none"></div>
                        <div class="absolute top-1/2 left-2 right-2 border-b border-white/20 pointer-events-none"></div>
                        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 border border-white/20 rounded-full pointer-events-none"></div>
                        <div class="absolute top-2 left-1/2 -translate-x-1/2 w-36 h-16 border-b border-x border-white/20 rounded-b-lg pointer-events-none"></div>
                        <div class="absolute bottom-2 left-1/2 -translate-x-1/2 w-36 h-16 border-t border-x border-white/20 rounded-t-lg pointer-events-none"></div>

                        <!-- Slots con los 11 titulares -->
                        @for (slot of tacticalPitchSlots(); track slot.slotNumber) {
                          <div
                            class="absolute -translate-x-1/2 -translate-y-1/2 transition-all cursor-pointer z-10"
                            [style.left.%]="slot.x"
                            [style.top.%]="slot.y"
                            (click)="handleStarterPitchClick(slot.player)"
                          >
                            @if (slot.player; as player) {
                              @let isOut = isStarterSelectedAsOutgoing(player.playerInstanceId);
                              @let pending = getPendingChangeForStarter(player.playerInstanceId);

                              <div
                                class="group flex flex-col items-center"
                                [title]="(player.displayName || 'Titular') + ' · ' + (player.position || slot.label) + (pending ? ' (Saliente hacia ' + pending.incomingName + ')' : isOut ? ' (Marcado para salir)' : '')"
                              >
                                <!-- Avatar circle -->
                                <div class="relative">
                                  <div
                                    class="w-10 h-10 sm:w-11 sm:h-11 rounded-full flex flex-col items-center justify-center font-bold text-xs text-white border transition-all duration-200 shadow-md group-hover:scale-105"
                                    [ngClass]="
                                      isOut
                                        ? 'bg-amber-600 border-amber-300 ring-4 ring-amber-400/50 scale-110 shadow-amber-500/30 animate-pulse'
                                        : pending
                                        ? 'bg-rose-950/90 border-rose-500 ring-2 ring-rose-400/60'
                                        : 'bg-slate-900 border-white/30 hover:border-emerald-400'
                                    "
                                  >
                                    <span class="text-[9px] font-black tracking-wider leading-none"
                                      [ngClass]="isOut ? 'text-white' : pending ? 'text-rose-300' : 'text-emerald-400'"
                                    >
                                      {{ slot.label }}
                                    </span>
                                    <span class="text-[8px] font-mono text-slate-300 opacity-80 leading-tight">
                                      #{{ slot.slotNumber }}
                                    </span>
                                  </div>

                                  <!-- Escudo del club real si existe -->
                                  @if (getPlayerRealClubCrestUrl(player); as crestUrl) {
                                    <img
                                      [src]="crestUrl"
                                      [alt]="getPlayerRealClub(player)?.shortName || 'Club'"
                                      (error)="onCrestError($event)"
                                      referrerpolicy="no-referrer"
                                      class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full object-contain bg-white dark:bg-slate-900 p-0.5 border border-white/70 dark:border-slate-700 shadow-xs"
                                      [title]="getPlayerRealClubName(player)"
                                    />
                                  }

                                  <!-- Icono de sustitución o salida -->
                                  @if (pending) {
                                    <div
                                      class="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-rose-600 text-white flex items-center justify-center text-[10px] font-black border border-white shadow-xs"
                                      title="Cambio preparado: sale hacia {{ pending.incomingName }}"
                                    >
                                      🔄
                                    </div>
                                  } @else if (isOut) {
                                    <div
                                      class="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-amber-400 text-slate-900 flex items-center justify-center text-[10px] font-black border border-white shadow-xs"
                                      title="Seleccionado como saliente"
                                    >
                                      ▼
                                    </div>
                                  }
                                </div>

                                <!-- Nombre del titular -->
                                <div class="mt-1 flex flex-col items-center max-w-[80px]">
                                  <span
                                    class="px-1.5 py-0.5 rounded text-[10px] font-semibold truncate border shadow-xs max-w-full text-center"
                                    [ngClass]="
                                      isOut
                                        ? 'bg-amber-500 text-slate-950 border-amber-300 font-bold'
                                        : pending
                                        ? 'bg-rose-900 text-rose-100 border-rose-600/80'
                                        : 'bg-slate-900/90 text-slate-100 border-white/10'
                                    "
                                  >
                                    {{ getPlayerShortLastName(player.displayName) }}
                                  </span>

                                  @if (pending) {
                                    <span class="text-[8px] font-bold text-rose-300 bg-rose-950/80 px-1 rounded truncate max-w-full leading-tight mt-0.5">
                                      ➔ {{ getPlayerShortLastName(pending.incomingName) }}
                                    </span>
                                  } @else if (isOut) {
                                    <span class="text-[8px] font-bold text-amber-300 bg-amber-950/90 px-1 rounded leading-tight mt-0.5">
                                      Saliente
                                    </span>
                                  }
                                </div>
                              </div>
                            } @else {
                              <div class="flex flex-col items-center">
                                <div class="w-9 h-9 rounded-full border border-dashed border-emerald-700/60 bg-emerald-900/30 text-emerald-300/80 flex items-center justify-center text-xs font-semibold">
                                  {{ slot.label }}
                                </div>
                                <span class="text-[9px] text-emerald-300/60 mt-0.5">Vacío</span>
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <div class="text-[11px] text-slate-500 dark:text-slate-400 text-center">
                        Conserva la formación y el slot asignado al entrar el sustituto.
                      </div>
                    </div>

                    <!-- COLUMNA DERECHA: BANQUILLO, PREVIEW DE INTERCAMBIO Y LOTE -->
                    <div class="lg:col-span-5 space-y-4">
                      
                      <!-- Banquillo táctico capturado (0 a 5 suplentes) -->
                      <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-4 space-y-3 shadow-xs">
                        <div class="flex items-center justify-between pb-2 border-b border-slate-100 dark:border-slate-800">
                          <div class="flex items-center space-x-1.5">
                            <app-icon name="users" [size]="15" class="text-emerald-500" />
                            <h4 class="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-white">
                              Banquillo Táctico
                            </h4>
                            <span class="px-1.5 py-0.2 rounded text-[10px] font-mono font-bold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300">
                              {{ tl.lineup?.bench?.length || 0 }}/5
                            </span>
                          </div>

                          @if (selectedIncoming()) {
                            <button
                              type="button"
                              (click)="selectedIncoming.set(null)"
                              class="text-[11px] text-slate-400 hover:text-rose-500 cursor-pointer font-medium"
                            >
                              Deseleccionar
                            </button>
                          }
                        </div>

                        <p class="text-[11px] text-slate-500 dark:text-slate-400">
                          Toca un suplente para asignarlo como sustituto del titular marcado.
                        </p>

                        <!-- Lista interactiva de los suplentes del banquillo -->
                        <div class="space-y-1.5">
                          @for (bp of tl.lineup?.bench || []; track bp.playerInstanceId) {
                            @let isRetired = isBenchPlayerRetired(bp.playerInstanceId);
                            @let isIn = isBenchSelectedAsIncoming(bp.playerInstanceId);
                            @let pending = getPendingChangeForBench(bp.playerInstanceId);

                            <div
                              (click)="!isRetired && handleBenchPlayerClick(bp)"
                              class="p-2.5 rounded-xl border transition-all text-xs flex items-center justify-between select-none"
                              [ngClass]="
                                isRetired
                                  ? 'bg-slate-100/60 dark:bg-slate-950/40 border-slate-200/50 dark:border-slate-800/40 opacity-50 cursor-not-allowed'
                                  : isIn
                                  ? 'bg-emerald-50 dark:bg-emerald-950/60 border-emerald-400 ring-2 ring-emerald-500/40 cursor-pointer shadow-xs'
                                  : pending
                                  ? 'bg-emerald-50/50 dark:bg-emerald-950/30 border-emerald-300/60 cursor-pointer'
                                  : 'bg-slate-50 dark:bg-slate-950/60 border-slate-200/80 dark:border-slate-800 hover:border-emerald-400 cursor-pointer'
                              "
                            >
                              <!-- Info del suplente -->
                              <div class="flex items-center space-x-2.5 min-w-0 pr-2">
                                <span
                                  class="w-7 h-6 rounded text-[10px] font-mono font-bold flex items-center justify-center shrink-0 border shadow-2xs"
                                  [ngClass]="getPositionBadgeClass(bp.position)"
                                >
                                  {{ bp.position || 'SUP' }}
                                </span>

                                @if (getPlayerRealClubCrestUrl(bp); as crestUrl) {
                                  <div
                                    class="w-6 h-6 rounded-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center p-0.5 shrink-0 shadow-2xs"
                                    [title]="getPlayerRealClubName(bp)"
                                  >
                                    <img
                                      [src]="crestUrl"
                                      [alt]="getPlayerRealClub(bp)?.shortName || 'Club'"
                                      (error)="onCrestError($event)"
                                      referrerpolicy="no-referrer"
                                      class="w-full h-full object-contain"
                                    />
                                  </div>
                                }

                                <div class="min-w-0">
                                  <div class="flex items-center space-x-1.5">
                                    <span class="font-bold text-slate-800 dark:text-slate-200 truncate">
                                      {{ bp.displayName || bp.playerInstanceId.substring(0, 8) }}
                                    </span>
                                    @if (getPlayerRealClub(bp)?.shortName; as clubShort) {
                                      <span class="text-[10px] text-slate-400 dark:text-slate-500 font-mono shrink-0">
                                        {{ clubShort }}
                                      </span>
                                    }
                                    <span class="text-[10px] text-slate-400 font-mono">
                                      #{{ bp.benchPlace || ($index + 1) }}
                                    </span>
                                  </div>
                                  <div class="flex items-center space-x-1 text-[10px]">
                                    @if (bp.type) {
                                      <span class="text-slate-400">{{ bp.type }}</span>
                                    }
                                    @if (pending) {
                                      <span class="text-emerald-600 dark:text-emerald-400 font-semibold">
                                        • Entra por {{ getPlayerShortLastName(pending.outgoingName) }}
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>

                              <!-- Estado / Badge derecho -->
                              <div class="shrink-0">
                                @if (isRetired) {
                                  <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-300 border border-rose-200 dark:border-rose-900">
                                    Retirado
                                  </span>
                                } @else if (isIn) {
                                  <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-600 text-white flex items-center space-x-1 shadow-xs">
                                    <app-icon name="check" [size]="11" />
                                    <span>Elegido</span>
                                  </span>
                                } @else if (pending) {
                                  <span class="px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-800">
                                    En el lote
                                  </span>
                                } @else {
                                  <span class="text-[11px] font-semibold text-emerald-600 dark:text-emerald-400 hover:underline">
                                    Elegir
                                  </span>
                                }
                              </div>
                            </div>
                          } @empty {
                            <div class="p-4 rounded-xl bg-slate-50 dark:bg-slate-950 text-center text-xs text-slate-400">
                              No hay suplentes en el banquillo para este encuentro.
                            </div>
                          }
                        </div>
                      </div>

                      <!-- Panel de emparejamiento activo -->
                      <div class="p-3.5 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs space-y-3">
                        <div class="text-[11px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">
                          Intercambio a añadir
                        </div>

                        <div class="grid grid-cols-2 gap-2 text-xs">
                          <!-- Saliente seleccionado -->
                          <div
                            class="p-2.5 rounded-xl border flex flex-col justify-between"
                            [ngClass]="selectedOutgoing() ? 'bg-amber-50/70 dark:bg-amber-950/40 border-amber-300 dark:border-amber-700' : 'bg-slate-50 dark:bg-slate-950 border-dashed border-slate-200 dark:border-slate-800'"
                          >
                            <span class="text-[10px] uppercase font-bold text-amber-600 dark:text-amber-400">
                              ▼ Titular saliente
                            </span>
                            @if (getSelectedOutgoingPlayer(); as outP) {
                              <div class="mt-1">
                                <span class="font-bold text-slate-900 dark:text-white block truncate">
                                  {{ outP.displayName || outP.playerInstanceId }}
                                </span>
                                <span class="text-[10px] text-slate-500">
                                  Slot {{ outP.slot || '?' }} · {{ outP.position || 'JUG' }}
                                </span>
                              </div>
                            } @else {
                              <span class="text-[11px] text-slate-400 italic mt-1">
                                Toca un titular en el campo
                              </span>
                            }
                          </div>

                          <!-- Entrante seleccionado -->
                          <div
                            class="p-2.5 rounded-xl border flex flex-col justify-between"
                            [ngClass]="selectedIncoming() ? 'bg-emerald-50/70 dark:bg-emerald-950/40 border-emerald-300 dark:border-emerald-700' : 'bg-slate-50 dark:bg-slate-950 border-dashed border-slate-200 dark:border-slate-800'"
                          >
                            <span class="text-[10px] uppercase font-bold text-emerald-600 dark:text-emerald-400">
                              ▲ Suplente entrante
                            </span>
                            @if (getSelectedIncomingPlayer(); as inP) {
                              <div class="mt-1">
                                <span class="font-bold text-slate-900 dark:text-white block truncate">
                                  {{ inP.displayName || inP.playerInstanceId }}
                                </span>
                                <span class="text-[10px] text-slate-500">
                                  Banquillo #{{ inP.benchPlace || '?' }} · {{ inP.position || 'JUG' }}
                                </span>
                              </div>
                            } @else {
                              <span class="text-[11px] text-slate-400 italic mt-1">
                                Toca un suplente del banquillo
                              </span>
                            }
                          </div>
                        </div>

                        <!-- Botón añadir al lote -->
                        <div class="flex items-center justify-between pt-1">
                          @if (selectedOutgoing() || selectedIncoming()) {
                            <button
                              type="button"
                              (click)="clearActiveSelection()"
                              class="text-xs text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 cursor-pointer font-medium"
                            >
                              Limpiar selección
                            </button>
                          } @else {
                            <span></span>
                          }

                          <button
                            type="button"
                            (click)="addExchangeToBatch()"
                            [disabled]="!selectedOutgoing() || !selectedIncoming() || pendingChanges().length >= tl.substitutionsRemaining"
                            class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-xs rounded-xl disabled:opacity-40 disabled:cursor-not-allowed transition-colors flex items-center space-x-1.5 cursor-pointer shadow-xs"
                          >
                            <app-icon name="plus" [size]="13" />
                            <span>Añadir al lote</span>
                          </button>
                        </div>
                      </div>

                      <!-- Lote actual de intercambios preparados -->
                      @if (pendingChanges().length > 0) {
                        <div class="p-4 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 space-y-3 shadow-xs">
                          <div class="flex items-center justify-between">
                            <span class="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                              Lote preparado ({{ pendingChanges().length }})
                            </span>
                            <span class="text-[11px] font-mono text-emerald-600 dark:text-emerald-400 font-bold">
                              1 ventana consumida
                            </span>
                          </div>

                          <div class="space-y-1.5">
                            @for (change of pendingChanges(); track $index) {
                              <div class="p-2.5 rounded-xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 flex items-center justify-between text-xs">
                                <div class="flex items-center space-x-2">
                                  <span class="font-bold text-rose-600 dark:text-rose-400">
                                    ▼ {{ getStarterDisplayName(change.outgoing) }}
                                  </span>
                                  <app-icon name="arrow-right" [size]="13" class="text-slate-400" />
                                  <span class="font-bold text-emerald-600 dark:text-emerald-400">
                                    ▲ {{ getBenchDisplayName(change.incoming) }}
                                  </span>
                                </div>
                                <button
                                  type="button"
                                  (click)="removeExchangeFromBatch($index)"
                                  class="text-slate-400 hover:text-rose-600 cursor-pointer p-1"
                                  title="Quitar del lote"
                                >
                                  <app-icon name="trash-2" [size]="13" />
                                </button>
                              </div>
                            }
                          </div>

                          <!-- Resumen y aviso obligatorio -->
                          <div class="p-3 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800 text-xs text-amber-800 dark:text-amber-300 space-y-1">
                            <div class="flex items-center space-x-1.5 font-bold">
                              <app-icon name="alert-triangle" [size]="14" class="text-amber-600 dark:text-amber-400 shrink-0" />
                              <span>Consumirás 1 ventana y {{ pendingChanges().length }} {{ pendingChanges().length === 1 ? 'sustitución' : 'sustituciones' }}</span>
                            </div>
                            <p class="text-[11px] leading-relaxed">
                              Los salientes no podrán volver a jugar este partido. Un suplente que entre podrá ser reemplazado posteriormente en otra ventana.
                            </p>
                          </div>

                          <div class="pt-1 flex items-center justify-end space-x-2">
                            @if (canRetryConfirmation()) {
                              <button
                                type="button"
                                (click)="confirmSubstitutions(true)"
                                [disabled]="isSubmittingWindow()"
                                class="px-3.5 py-2.5 bg-amber-600 hover:bg-amber-700 text-white font-bold text-xs rounded-xl shadow-xs transition-all flex items-center space-x-1.5 cursor-pointer"
                              >
                                <app-icon name="refresh-cw" [size]="13" [class]="isSubmittingWindow() ? 'animate-spin' : ''" />
                                <span>Reintentar confirmación</span>
                              </button>
                            }
                            <button
                              type="button"
                              (click)="confirmSubstitutions(false)"
                              [disabled]="isSubmittingWindow() || pendingChanges().length === 0"
                              class="w-full sm:w-auto px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs rounded-xl shadow-xs transition-all flex items-center justify-center space-x-1.5 disabled:opacity-50 cursor-pointer"
                            >
                              @if (isSubmittingWindow()) {
                                <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                <span>Confirmando ventana...</span>
                              } @else {
                                <app-icon name="check" [size]="14" />
                                <span>Confirmar ventana ({{ pendingChanges().length }})</span>
                              }
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                } @else {
                  <!-- VISTA SI NO QUEDAN RECURSOS: CAMPO EN MODO REVISIÓN + MENSAJE -->
                  <div class="space-y-4">
                    <div class="p-4 rounded-2xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800 text-center text-xs text-amber-800 dark:text-amber-300">
                      Has agotado las 3 ventanas o las 5 sustituciones permitidas para esta jornada. Consulta la alineación final sobre el campo.
                    </div>

                    <!-- Campo en modo lectura -->
                    <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-4 space-y-3 shadow-xs max-w-md mx-auto">
                      <h4 class="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-white text-center">
                        Once definitivo en juego ({{ tl.lineup?.formation || '4-4-2' }})
                      </h4>
                      <div class="relative w-full aspect-[3/4] bg-emerald-950/90 dark:bg-[#0c131a] rounded-2xl border border-emerald-800/40 dark:border-white/10 overflow-hidden select-none shadow-inner p-2 sm:p-3">
                        <div class="absolute inset-2 border border-white/20 rounded-xl pointer-events-none"></div>
                        <div class="absolute top-1/2 left-2 right-2 border-b border-white/20 pointer-events-none"></div>
                        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 border border-white/20 rounded-full pointer-events-none"></div>
                        <div class="absolute top-2 left-1/2 -translate-x-1/2 w-36 h-16 border-b border-x border-white/20 rounded-b-lg pointer-events-none"></div>
                        <div class="absolute bottom-2 left-1/2 -translate-x-1/2 w-36 h-16 border-t border-x border-white/20 rounded-t-lg pointer-events-none"></div>

                        @for (slot of tacticalPitchSlots(); track slot.slotNumber) {
                          <div
                            class="absolute -translate-x-1/2 -translate-y-1/2 transition-all z-10"
                            [style.left.%]="slot.x"
                            [style.top.%]="slot.y"
                          >
                            @if (slot.player; as player) {
                              <div class="flex flex-col items-center">
                                <div class="w-10 h-10 rounded-full flex flex-col items-center justify-center font-bold text-xs text-white border border-white/30 bg-slate-900 shadow-md">
                                  <span class="text-[9px] font-black text-emerald-400 tracking-wider leading-none">{{ slot.label }}</span>
                                  <span class="text-[8px] font-mono text-slate-300 opacity-80 leading-tight">#{{ slot.slotNumber }}</span>
                                </div>
                                <span class="px-1.5 py-0.5 rounded text-[10px] font-semibold truncate border shadow-xs max-w-[80px] text-center bg-slate-900/90 text-slate-100 border-white/10 mt-1">
                                  {{ getPlayerShortLastName(player.displayName) }}
                                </span>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }

                <!-- Jugadores retirados -->
                @if (tl.retired && tl.retired.length > 0) {
                  <div class="p-4 rounded-2xl bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 space-y-2 text-xs">
                    <h5 class="font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 text-[10px]">
                      Jugadores Retirados (no pueden reingresar)
                    </h5>
                    <div class="flex flex-wrap gap-1.5">
                      @for (retId of tl.retired; track retId) {
                        <span class="px-2.5 py-1 rounded-lg bg-rose-50 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300 border border-rose-200 dark:border-rose-900 font-medium">
                          {{ getStarterDisplayName(retId) }}
                        </span>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          } @else if (activeModalView() === 'details') {
            <!-- VISTA DE DETALLES TÉCNICOS Y MÉTRICAS DEL MOTOR -->
            @if (isLoadingLive() && !matchLive()) {
              <div class="py-16 text-center text-slate-400 text-xs flex flex-col items-center justify-center space-y-3">
                <span class="animate-spin text-emerald-600 dark:text-emerald-400 text-2xl">⏳</span>
                <p class="font-medium text-slate-600 dark:text-slate-300">
                  Consultando métricas del motor y detalles del partido...
                </p>
              </div>
            } @else if (isLiveNotAvailable() || !matchLive()) {
              <div class="p-6 sm:p-8 rounded-2xl bg-slate-50/70 dark:bg-slate-950/70 border border-slate-200 dark:border-slate-800 text-center flex flex-col items-center justify-center space-y-4 shadow-xs">
                <div class="w-14 h-14 rounded-2xl bg-emerald-50 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 border border-emerald-200/80 dark:border-emerald-800/80 flex items-center justify-center shadow-xs">
                  <app-icon name="trending-up" [size]="26" />
                </div>
                <div class="space-y-1.5 max-w-md">
                  <h4 class="text-base font-bold text-slate-900 dark:text-white">
                    Métricas del motor aún no disponibles
                  </h4>
                  <p class="text-xs sm:text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                    Los cálculos de potencia ajustada, fuerza ofensiva y modificadores de cuerpo técnico se calculan cuando el partido está en juego o ha sido disputado.
                  </p>
                </div>
              </div>
            } @else {
              <div
                id="technical-details-card"
                class="p-4 sm:p-5 rounded-2xl bg-slate-50 dark:bg-slate-950 border border-emerald-500/30 dark:border-emerald-500/20 shadow-xs space-y-4 animate-in fade-in transition-all"
              >
                <div class="flex items-center justify-between pb-3 border-b border-slate-200/70 dark:border-slate-800/80">
                  <div class="flex items-center space-x-2">
                    <span class="p-1.5 rounded-lg bg-emerald-100 dark:bg-emerald-950/80 text-emerald-700 dark:text-emerald-400">
                      <app-icon name="trending-up" [size]="15" />
                    </span>
                    <div>
                      <h4 class="text-xs font-bold uppercase tracking-wider text-slate-900 dark:text-white">
                        Detalles Técnicos y Métricas del Motor
                      </h4>
                      <p class="text-[11px] text-slate-500 dark:text-slate-400">
                        Cálculos de fuerza, modificadores de cuerpo técnico y proyección de simulación
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Two columns: Home vs Away -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs">
                  <!-- Local Details -->
                  <div class="p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 space-y-3.5 shadow-2xs">
                    <div class="flex items-center space-x-2 pb-2 border-b border-slate-100 dark:border-slate-800">
                      <app-club-shield
                        [clubId]="inspectedFixture()!.homeClubId"
                        [clubName]="inspectedFixture()!.homeClubName"
                        [clubCode]="inspectedFixture()!.homeClubCode"
                        [shield]="inspectedFixture()!.homeClubId === game.userClub()?.id ? game.userClub()?.shield : null"
                        size="xs"
                        customClass="shrink-0"
                      />
                      <span class="font-bold text-slate-900 dark:text-white truncate">
                        {{ inspectedFixture()!.homeClubName }} (Local)
                      </span>
                    </div>

                    <!-- 1. Modificadores de Asistencia y Forma -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        Modificadores de Entorno
                      </span>
                      <div class="grid grid-cols-2 gap-2 font-mono">
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">attendanceModifierPercent</span>
                          <span class="text-xs font-bold text-slate-900 dark:text-slate-100">
                            {{ formatPercent(matchLive()?.home?.score?.attendanceModifierPercent) }}
                          </span>
                        </div>
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">formModifierPercent</span>
                          <span class="text-xs font-bold text-slate-900 dark:text-slate-100">
                            {{ formatPercent(matchLive()?.home?.score?.formModifierPercent) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- 2. Modificadores del Staff (staffModifierPercents) -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        staffModifierPercents
                      </span>
                      <div class="grid grid-cols-4 gap-1.5 font-mono text-center">
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">POR</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.staffModifierPercents?.GOALKEEPER, 1) }}
                          </span>
                        </div>
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">DEF</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.staffModifierPercents?.DEFENCE, 1) }}
                          </span>
                        </div>
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">MED</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.staffModifierPercents?.MIDFIELD, 1) }}
                          </span>
                        </div>
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">DEL</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.staffModifierPercents?.FORWARD, 1) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- 3. Potencia Ajustada (staffAdjustedPower) -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        staffAdjustedPower
                      </span>
                      <div class="grid grid-cols-3 gap-1.5 font-mono text-center">
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">attack</span>
                          <span class="text-xs font-bold text-rose-600 dark:text-rose-400">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.staffAdjustedPower?.attack, 4) }}
                          </span>
                        </div>
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">midfield</span>
                          <span class="text-xs font-bold text-emerald-600 dark:text-emerald-400">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.staffAdjustedPower?.midfield, 4) }}
                          </span>
                        </div>
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">defense</span>
                          <span class="text-xs font-bold text-blue-600 dark:text-blue-400">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.staffAdjustedPower?.defense, 4) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- 4. Fuerza Ofensiva e Impacto -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        Métricas Ofensivas Avanzadas
                      </span>
                      <div class="space-y-1.5 font-mono text-xs">
                        <div class="flex items-center justify-between p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="text-slate-500 dark:text-slate-400 font-sans">offensiveStrength</span>
                          <span class="font-bold text-slate-900 dark:text-white" [title]="matchLive()?.home?.score?.optionB?.offensiveStrength">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.offensiveStrength, 4) }}
                          </span>
                        </div>
                        <div class="flex items-center justify-between p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="text-slate-500 dark:text-slate-400 font-sans">afterAttendance</span>
                          <span class="font-bold text-slate-900 dark:text-white" [title]="matchLive()?.home?.score?.optionB?.afterAttendance">
                            {{ formatNumber(matchLive()?.home?.score?.optionB?.afterAttendance, 4) }}
                          </span>
                        </div>
                        @if (matchLive()?.home?.score?.optionB?.goalInput !== undefined) {
                          <div class="flex items-center justify-between p-2 rounded-lg bg-emerald-50/50 dark:bg-emerald-950/20 border border-emerald-100 dark:border-emerald-800/40">
                            <span class="text-emerald-700 dark:text-emerald-400 font-sans">goalInput</span>
                            <span class="font-bold text-emerald-700 dark:text-emerald-300" [title]="matchLive()?.home?.score?.optionB?.goalInput">
                              {{ formatNumber(matchLive()?.home?.score?.optionB?.goalInput, 4) }}
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                  <!-- Visitante Details -->
                  <div class="p-4 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 space-y-3.5 shadow-2xs">
                    <div class="flex items-center space-x-2 pb-2 border-b border-slate-100 dark:border-slate-800">
                      <app-club-shield
                        [clubId]="inspectedFixture()!.awayClubId"
                        [clubName]="inspectedFixture()!.awayClubName"
                        [clubCode]="inspectedFixture()!.awayClubCode"
                        [shield]="inspectedFixture()!.awayClubId === game.userClub()?.id ? game.userClub()?.shield : null"
                        size="xs"
                        customClass="shrink-0"
                      />
                      <span class="font-bold text-slate-900 dark:text-white truncate">
                        {{ inspectedFixture()!.awayClubName }} (Visitante)
                      </span>
                    </div>

                    <!-- 1. Modificadores de Asistencia y Forma -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        Modificadores de Entorno
                      </span>
                      <div class="grid grid-cols-2 gap-2 font-mono">
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">attendanceModifierPercent</span>
                          <span class="text-xs font-bold text-slate-900 dark:text-slate-100">
                            {{ formatPercent(matchLive()?.away?.score?.attendanceModifierPercent) }}
                          </span>
                        </div>
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">formModifierPercent</span>
                          <span class="text-xs font-bold text-slate-900 dark:text-slate-100">
                            {{ formatPercent(matchLive()?.away?.score?.formModifierPercent) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- 2. Modificadores del Staff (staffModifierPercents) -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        staffModifierPercents
                      </span>
                      <div class="grid grid-cols-4 gap-1.5 font-mono text-center">
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">POR</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.staffModifierPercents?.GOALKEEPER, 1) }}
                          </span>
                        </div>
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">DEF</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.staffModifierPercents?.DEFENCE, 1) }}
                          </span>
                        </div>
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">MED</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.staffModifierPercents?.MIDFIELD, 1) }}
                          </span>
                        </div>
                        <div class="p-1.5 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[9px] text-slate-400 font-sans">DEL</span>
                          <span class="text-[11px] font-bold text-slate-900 dark:text-slate-100">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.staffModifierPercents?.FORWARD, 1) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- 3. Potencia Ajustada (staffAdjustedPower) -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        staffAdjustedPower
                      </span>
                      <div class="grid grid-cols-3 gap-1.5 font-mono text-center">
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">attack</span>
                          <span class="text-xs font-bold text-rose-600 dark:text-rose-400">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.staffAdjustedPower?.attack, 4) }}
                          </span>
                        </div>
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">midfield</span>
                          <span class="text-xs font-bold text-emerald-600 dark:text-emerald-400">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.staffAdjustedPower?.midfield, 4) }}
                          </span>
                        </div>
                        <div class="p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="block text-[10px] text-slate-400 font-sans">defense</span>
                          <span class="text-xs font-bold text-blue-600 dark:text-blue-400">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.staffAdjustedPower?.defense, 4) }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- 4. Fuerza Ofensiva e Impacto -->
                    <div>
                      <span class="block text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mb-1.5">
                        Métricas Ofensivas Avanzadas
                      </span>
                      <div class="space-y-1.5 font-mono text-xs">
                        <div class="flex items-center justify-between p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="text-slate-500 dark:text-slate-400 font-sans">offensiveStrength</span>
                          <span class="font-bold text-slate-900 dark:text-white" [title]="matchLive()?.away?.score?.optionB?.offensiveStrength">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.offensiveStrength, 4) }}
                          </span>
                        </div>
                        <div class="flex items-center justify-between p-2 rounded-lg bg-slate-50 dark:bg-slate-950 border border-slate-100 dark:border-slate-800/80">
                          <span class="text-slate-500 dark:text-slate-400 font-sans">afterAttendance</span>
                          <span class="font-bold text-slate-900 dark:text-white" [title]="matchLive()?.away?.score?.optionB?.afterAttendance">
                            {{ formatNumber(matchLive()?.away?.score?.optionB?.afterAttendance, 4) }}
                          </span>
                        </div>
                        @if (matchLive()?.away?.score?.optionB?.goalInput !== undefined) {
                          <div class="flex items-center justify-between p-2 rounded-lg bg-emerald-50/50 dark:bg-emerald-950/20 border border-emerald-100 dark:border-emerald-800/40">
                            <span class="text-emerald-700 dark:text-emerald-400 font-sans">goalInput</span>
                            <span class="font-bold text-emerald-700 dark:text-emerald-300" [title]="matchLive()?.away?.score?.optionB?.goalInput">
                              {{ formatNumber(matchLive()?.away?.score?.optionB?.goalInput, 4) }}
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          } @else {
            <!-- VISTA EN DIRECTO NORMAL -->
            <!-- Loading State -->
            @if (isLoadingLive()) {
            <div class="py-16 text-center text-slate-400 text-xs flex flex-col items-center justify-center space-y-3">
              <span class="animate-spin text-emerald-600 dark:text-emerald-400 text-2xl">⏳</span>
              <p class="font-medium text-slate-600 dark:text-slate-300">
                Consultando jugadores y puntuaciones del partido...
              </p>
            </div>
          }

          <!-- Match Data Not Available State (Scheduled / Not yet played / No live data) -->
          @if (isLiveNotAvailable() && !isLoadingLive()) {
            <div class="p-6 sm:p-8 rounded-2xl bg-slate-50/70 dark:bg-slate-950/70 border border-slate-200 dark:border-slate-800 text-center flex flex-col items-center justify-center space-y-4 shadow-xs">
              <div class="w-14 h-14 rounded-2xl bg-blue-50 dark:bg-blue-950/60 text-blue-600 dark:text-blue-400 border border-blue-200/80 dark:border-blue-800/80 flex items-center justify-center shadow-xs">
                <app-icon name="calendar" [size]="26" />
              </div>

              <div class="space-y-1.5 max-w-md">
                <h4 class="text-base font-bold text-slate-900 dark:text-white">
                  Los datos del partido aún no están disponibles
                </h4>
                <p class="text-xs sm:text-sm text-slate-500 dark:text-slate-400 leading-relaxed">
                  Este encuentro todavía no se ha disputado o las actas en directo aún no han sido generadas. Podrás consultar las alineaciones, eventos y puntuaciones una vez comience el partido.
                </p>
              </div>

              <!-- Information badges -->
              <div class="flex flex-wrap items-center justify-center gap-2 pt-1 text-xs">
                <div class="inline-flex items-center space-x-1.5 px-3 py-1 rounded-full bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700/80 shadow-2xs">
                  <app-icon name="info" [size]="13" class="text-slate-400 shrink-0" />
                  <span>Jornada {{ currentMatchdayNumber() || selectedMatchdayNumber }}</span>
                </div>
                <div class="inline-flex items-center space-x-1.5 px-3 py-1 rounded-full bg-blue-50 dark:bg-blue-950/60 text-blue-700 dark:text-blue-300 border border-blue-200/60 dark:border-blue-800/60 shadow-2xs">
                  <app-icon name="clock" [size]="13" class="shrink-0" />
                  <span>Estado: {{ getLiveStatusBadge().label }}</span>
                </div>
              </div>              
            </div>
          }

          <!-- Unexpected Error State (for non-404 network or server errors) -->
          @if (liveError() && !isLoadingLive() && !isLiveNotAvailable()) {
            <div class="p-4 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 text-xs flex items-center justify-between gap-3">
              <div class="flex items-center space-x-2">
                <app-icon name="alert-circle" [size]="16" class="shrink-0" />
                <span>{{ liveError() }}</span>
              </div>
              <button
                type="button"
                (click)="loadMatchLive(inspectedFixture()!.id)"
                class="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-bold text-xs cursor-pointer shrink-0 transition-colors"
              >
                Reintentar
              </button>
            </div>
          }

          <!-- Live Players & Lineups Section -->
          @if (matchLive() && !isLoadingLive()) {
            <div class="space-y-4">
              <!-- Tab Selector (Both / Home / Away) -->
              <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-2">
                <h4 class="text-xs font-bold uppercase tracking-wider text-slate-500 dark:text-slate-400 flex items-center space-x-1.5">
                  <app-icon name="users" [size]="14" />
                  <span>Alineaciones</span>
                </h4>

                <div class="inline-flex p-1 rounded-xl bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-xs">
                  <button
                    type="button"
                    (click)="liveTab.set('both')"
                    class="px-2.5 py-1 rounded-lg font-semibold transition-all cursor-pointer"
                    [ngClass]="liveTab() === 'both' ? 'bg-white dark:bg-slate-900 text-slate-900 dark:text-white shadow-xs' : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white'"
                  >
                    Ambos
                  </button>
                  <button
                    type="button"
                    (click)="liveTab.set('home')"
                    class="px-2.5 py-1 rounded-lg font-semibold transition-all cursor-pointer"
                    [ngClass]="liveTab() === 'home' ? 'bg-white dark:bg-slate-900 text-slate-900 dark:text-white shadow-xs' : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white'"
                  >
                    Local
                  </button>
                  <button
                    type="button"
                    (click)="liveTab.set('away')"
                    class="px-2.5 py-1 rounded-lg font-semibold transition-all cursor-pointer"
                    [ngClass]="liveTab() === 'away' ? 'bg-white dark:bg-slate-900 text-slate-900 dark:text-white shadow-xs' : 'text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white'"
                  >
                    Visitante
                  </button>
                </div>
              </div>

              <!-- Lineups Grid -->
              <div
                class="grid gap-4"
                [ngClass]="liveTab() === 'both' ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1'"
              >
                <!-- HOME TEAM COLUMN -->
                @if (liveTab() === 'both' || liveTab() === 'home') {
                  <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-4 space-y-3.5 shadow-xs flex flex-col justify-between">
                    <!-- Column Header -->
                    <div>
                      <div class="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-800">
                        <div class="flex items-center space-x-2 min-w-0">
                          <app-club-shield
                            [clubId]="inspectedFixture()!.homeClubId"
                            [clubName]="inspectedFixture()!.homeClubName"
                            [clubCode]="inspectedFixture()!.homeClubCode"
                            [shield]="inspectedFixture()!.homeClubId === game.userClub()?.id ? game.userClub()?.shield : null"
                            size="xs"
                            customClass="shrink-0"
                          />
                          <span class="text-sm font-bold text-slate-900 dark:text-white truncate">
                            {{ inspectedFixture()!.homeClubName }}
                          </span>
                        </div>

                        <!-- Team Total Points -->
                        <span class="px-2.5 py-1 rounded-lg text-xs font-mono font-bold shrink-0 border"
                          [ngClass]="getTeamTotalPoints(matchLive()?.home?.players) !== null ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400 border-slate-200 dark:border-slate-700'"
                        >
                          @if (getTeamTotalPoints(matchLive()?.home?.players) !== null) {
                            {{ getTeamTotalPoints(matchLive()?.home?.players) }} pts
                            <span class="text-[10px] opacity-80 font-normal">({{ getScoredPlayersCount(matchLive()?.home?.players).scored }}/{{ getScoredPlayersCount(matchLive()?.home?.players).total }})</span>
                          } @else {
                            Puntos: Pendiente
                            <span class="text-[10px] opacity-80 font-normal">({{ getScoredPlayersCount(matchLive()?.home?.players).scored }}/{{ getScoredPlayersCount(matchLive()?.home?.players).total }})</span>
                          }
                        </span>
                      </div>

                      <!-- Revision mismatch warning -->
                      @if (matchLive()?.home?.calculatedLineupRevision !== null && matchLive()?.home?.calculatedLineupRevision !== undefined && matchLive()?.home?.calculatedLineupRevision !== matchLive()?.home?.lineupRevision) {
                        <div class="mt-2.5 p-2 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 text-[11px] flex items-center space-x-1.5">
                          <app-icon name="alert-circle" [size]="14" class="shrink-0" />
                          <span>El resultado publicado corresponde a una revisión anterior</span>
                        </div>
                      }

                      <!-- Ventanas y sustituciones consumidas -->
                      <div class="mt-2.5 flex items-center justify-between text-[11px] text-slate-500 dark:text-slate-400 bg-slate-50 dark:bg-slate-950 px-2.5 py-1.5 rounded-xl border border-slate-100 dark:border-slate-800/80">
                        <div class="flex items-center space-x-2">
                          <span>Ventanas: <strong class="text-slate-700 dark:text-slate-200">{{ matchLive()?.home?.windowsUsed ?? 0 }}/3</strong></span>
                          <span>•</span>
                          <span>Cambios: <strong class="text-slate-700 dark:text-slate-200">{{ matchLive()?.home?.substitutionsUsed ?? 0 }}/5</strong></span>
                        </div>
                        @if (matchLive()?.home?.lineupRevision !== undefined && matchLive()?.home?.lineupRevision !== null) {
                          <span class="font-mono text-[10px] text-slate-400">Rev. {{ matchLive()?.home?.lineupRevision }}</span>
                        }
                      </div>
                    </div>

                    <!-- Players by Lines -->
                    <div class="space-y-3 pt-1">
                      @for (group of getGroupedPlayers(matchLive()?.home?.players || []); track group.line) {
                        <div class="space-y-1.5">
                          <div class="flex items-center space-x-1.5 text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                            <span>{{ group.label }}</span>
                            <span class="text-[10px] text-slate-300 dark:text-slate-600">({{ group.players.length }})</span>
                          </div>

                          <div class="space-y-1">
                            @for (player of group.players; track player.playerInstanceId) {
                              <div class="p-2 rounded-xl bg-slate-50 dark:bg-slate-950/60 border border-slate-200/80 dark:border-slate-800/80 flex items-center justify-between text-xs hover:border-slate-300 dark:hover:border-slate-700 transition-colors">
                                <!-- Player Info -->
                                <div class="flex items-center space-x-2 min-w-0 pr-2">
                                  <span
                                    class="w-6 h-5 rounded text-[10px] font-mono font-bold flex items-center justify-center shrink-0 border shadow-2xs"
                                    [ngClass]="getPlayerLineBadge(player.line).class"
                                  >
                                    {{ getPlayerLineBadge(player.line).code }}
                                  </span>

                                  @if (getPlayerRealClubCrestUrl(player); as crestUrl) {
                                    <div
                                      class="w-6 h-6 rounded-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center p-0.5 shrink-0 shadow-2xs"
                                      [title]="getPlayerRealClubName(player)"
                                    >
                                      <img
                                        [src]="crestUrl"
                                        [alt]="getPlayerRealClub(player)?.shortName || 'Club'"
                                        (error)="onCrestError($event)"
                                        referrerpolicy="no-referrer"
                                        class="w-full h-full object-contain"
                                      />
                                    </div>
                                  }

                                  <div class="min-w-0">
                                    <div class="flex items-center space-x-1.5">
                                      <span class="font-semibold text-slate-800 dark:text-slate-200 block truncate" [title]="getPlayerDisplayName(player)">
                                        {{ getPlayerDisplayName(player) }}
                                      </span>
                                      @if (getPlayerRealClub(player)?.shortName; as clubShort) {
                                        <span class="text-[10px] text-slate-400 dark:text-slate-500 font-mono shrink-0">
                                          {{ clubShort }}
                                        </span>
                                      }
                                    </div>
                                    <div class="flex items-center space-x-1.5 text-[10px]">
                                      <span
                                        class="px-1 py-0.2 rounded font-medium"
                                        [ngClass]="player.type === 'REAL' ? 'bg-blue-100 text-blue-700 dark:bg-blue-950/70 dark:text-blue-300' : 'bg-amber-100 text-amber-700 dark:bg-amber-950/70 dark:text-amber-300'"
                                      >
                                        {{ player.type }}
                                      </span>
                                      @if (player.status === 'PENDING') {
                                        <span class="text-slate-400 dark:text-slate-500 flex items-center space-x-0.5">
                                          <app-icon name="clock" [size]="10" />
                                          <span>Pendiente</span>
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>

                                <!-- Player Points -->
                                <div class="shrink-0 text-right">
                                  @if (player.points !== null && player.points !== undefined) {
                                    <span
                                      class="inline-block px-2.5 py-1 rounded-lg font-mono font-bold text-xs shadow-2xs border"
                                      [ngClass]="player.points > 0 ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800' : 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-200 dark:border-slate-700'"
                                    >
                                      {{ player.points }}
                                    </span>
                                  } @else {
                                    <span class="inline-flex items-center space-x-1 px-2 py-0.5 rounded-lg font-mono text-[11px] bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500 border border-slate-200/60 dark:border-slate-800">
                                      <app-icon name="clock" [size]="11" />
                                      <span>—</span>
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      } @empty {
                        <div class="py-6 text-center text-slate-400 text-xs">
                          No hay jugadores registrados en el acta de este club.
                        </div>
                      }
                    </div>

                    <!-- Banquillo Home -->
                    @if (matchLive()?.home?.bench && matchLive()!.home.bench!.length > 0) {
                      <div class="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800 space-y-2">
                        <div class="flex items-center justify-between text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          <span>Banquillo ({{ matchLive()!.home.bench!.length }})</span>
                        </div>
                        <div class="space-y-1">
                          @for (benchPlayer of matchLive()!.home.bench!; track benchPlayer.playerInstanceId) {
                            <div class="p-2 rounded-xl bg-slate-50 dark:bg-slate-950/40 border border-slate-200/60 dark:border-slate-800/60 flex items-center justify-between text-xs">
                              <div class="flex items-center space-x-2 min-w-0 pr-2">
                                <span class="w-6 h-5 rounded text-[10px] font-mono font-bold flex items-center justify-center shrink-0 border shadow-2xs bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-700">
                                  {{ benchPlayer.position || 'SUP' }}
                                </span>

                                @if (getPlayerRealClubCrestUrl(benchPlayer); as crestUrl) {
                                  <div
                                    class="w-6 h-6 rounded-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center p-0.5 shrink-0 shadow-2xs"
                                    [title]="getPlayerRealClubName(benchPlayer)"
                                  >
                                    <img
                                      [src]="crestUrl"
                                      [alt]="getPlayerRealClub(benchPlayer)?.shortName || 'Club'"
                                      (error)="onCrestError($event)"
                                      referrerpolicy="no-referrer"
                                      class="w-full h-full object-contain"
                                    />
                                  </div>
                                }

                                <div class="min-w-0">
                                  <div class="flex items-center space-x-1.5">
                                    <span class="font-semibold text-slate-800 dark:text-slate-200 block truncate">
                                      {{ benchPlayer.displayName || 'Suplente' }}
                                    </span>
                                    @if (getPlayerRealClub(benchPlayer)?.shortName; as clubShort) {
                                      <span class="text-[10px] text-slate-400 dark:text-slate-500 font-mono shrink-0">
                                        {{ clubShort }}
                                      </span>
                                    }
                                  </div>
                                  <div class="flex items-center space-x-1.5 text-[10px]">
                                    @if (benchPlayer.type) {
                                      <span class="px-1 py-0.2 rounded font-medium bg-slate-200/80 dark:bg-slate-800 text-slate-600 dark:text-slate-400">
                                        {{ benchPlayer.type }}
                                      </span>
                                    }
                                    @if (benchPlayer.retired) {
                                      <span class="px-1.5 py-0.2 rounded font-bold bg-rose-100 text-rose-700 dark:bg-rose-950/70 dark:text-rose-300">
                                        Retirado
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }

                    <!-- Historial de Sustituciones Home -->
                    @if (matchLive()?.home?.substitutionWindows && matchLive()!.home.substitutionWindows!.length > 0) {
                      <div class="mt-3 pt-3 border-t border-slate-100 dark:border-slate-800 space-y-2">
                        <div class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          Historial de Sustituciones
                        </div>
                        <div class="space-y-1.5">
                          @for (win of matchLive()!.home.substitutionWindows!; track win.windowId || $index) {
                            <div class="p-2 rounded-xl bg-slate-50/70 dark:bg-slate-950/40 border border-slate-200/60 dark:border-slate-800/60 text-xs space-y-1">
                              <div class="flex items-center justify-between text-[10px] text-slate-500 font-medium">
                                <span>Ventana {{ win.ordinal }}</span>
                                <span class="font-mono text-slate-400">Rev. {{ win.revisionBefore }} ➔ {{ win.revisionAfter }}</span>
                              </div>
                              @for (ch of win.changes; track ch.outgoing + ch.incoming) {
                                <div class="flex items-center space-x-1 text-slate-700 dark:text-slate-300 text-[11px]">
                                  <span class="text-rose-600 dark:text-rose-400 font-medium">▼ {{ ch.outgoingName || ch.outgoing }}</span>
                                  <span class="text-slate-400">➔</span>
                                  <span class="text-emerald-600 dark:text-emerald-400 font-medium">▲ {{ ch.incomingName || ch.incoming }}</span>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }

                <!-- AWAY TEAM COLUMN -->
                @if (liveTab() === 'both' || liveTab() === 'away') {
                  <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-4 space-y-3.5 shadow-xs flex flex-col justify-between">
                    <!-- Column Header -->
                    <div>
                      <div class="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-800">
                        <div class="flex items-center space-x-2 min-w-0">
                          <app-club-shield
                            [clubId]="inspectedFixture()!.awayClubId"
                            [clubName]="inspectedFixture()!.awayClubName"
                            [clubCode]="inspectedFixture()!.awayClubCode"
                            [shield]="inspectedFixture()!.awayClubId === game.userClub()?.id ? game.userClub()?.shield : null"
                            size="xs"
                            customClass="shrink-0"
                          />
                          <span class="text-sm font-bold text-slate-900 dark:text-white truncate">
                            {{ inspectedFixture()!.awayClubName }}
                          </span>
                        </div>

                        <!-- Team Total Points -->
                        <span class="px-2.5 py-1 rounded-lg text-xs font-mono font-bold shrink-0 border"
                          [ngClass]="getTeamTotalPoints(matchLive()?.away?.players) !== null ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800' : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400 border-slate-200 dark:border-slate-700'"
                        >
                          @if (getTeamTotalPoints(matchLive()?.away?.players) !== null) {
                            {{ getTeamTotalPoints(matchLive()?.away?.players) }} pts
                            <span class="text-[10px] opacity-80 font-normal">({{ getScoredPlayersCount(matchLive()?.away?.players).scored }}/{{ getScoredPlayersCount(matchLive()?.away?.players).total }})</span>
                          } @else {
                            Puntos: Pendiente
                            <span class="text-[10px] opacity-80 font-normal">({{ getScoredPlayersCount(matchLive()?.away?.players).scored }}/{{ getScoredPlayersCount(matchLive()?.away?.players).total }})</span>
                          }
                        </span>
                      </div>

                      <!-- Revision mismatch warning -->
                      @if (matchLive()?.away?.calculatedLineupRevision !== null && matchLive()?.away?.calculatedLineupRevision !== undefined && matchLive()?.away?.calculatedLineupRevision !== matchLive()?.away?.lineupRevision) {
                        <div class="mt-2.5 p-2 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 text-[11px] flex items-center space-x-1.5">
                          <app-icon name="alert-circle" [size]="14" class="shrink-0" />
                          <span>El resultado publicado corresponde a una revisión anterior</span>
                        </div>
                      }

                      <!-- Ventanas y sustituciones consumidas -->
                      <div class="mt-2.5 flex items-center justify-between text-[11px] text-slate-500 dark:text-slate-400 bg-slate-50 dark:bg-slate-950 px-2.5 py-1.5 rounded-xl border border-slate-100 dark:border-slate-800/80">
                        <div class="flex items-center space-x-2">
                          <span>Ventanas: <strong class="text-slate-700 dark:text-slate-200">{{ matchLive()?.away?.windowsUsed ?? 0 }}/3</strong></span>
                          <span>•</span>
                          <span>Cambios: <strong class="text-slate-700 dark:text-slate-200">{{ matchLive()?.away?.substitutionsUsed ?? 0 }}/5</strong></span>
                        </div>
                        @if (matchLive()?.away?.lineupRevision !== undefined && matchLive()?.away?.lineupRevision !== null) {
                          <span class="font-mono text-[10px] text-slate-400">Rev. {{ matchLive()?.away?.lineupRevision }}</span>
                        }
                      </div>
                    </div>

                    <!-- Players by Lines -->
                    <div class="space-y-3 pt-1">
                      @for (group of getGroupedPlayers(matchLive()?.away?.players || []); track group.line) {
                        <div class="space-y-1.5">
                          <div class="flex items-center space-x-1.5 text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                            <span>{{ group.label }}</span>
                            <span class="text-[10px] text-slate-300 dark:text-slate-600">({{ group.players.length }})</span>
                          </div>

                          <div class="space-y-1">
                            @for (player of group.players; track player.playerInstanceId) {
                              <div class="p-2 rounded-xl bg-slate-50 dark:bg-slate-950/60 border border-slate-200/80 dark:border-slate-800/80 flex items-center justify-between text-xs hover:border-slate-300 dark:hover:border-slate-700 transition-colors">
                                <!-- Player Info -->
                                <div class="flex items-center space-x-2 min-w-0 pr-2">
                                  <span
                                    class="w-6 h-5 rounded text-[10px] font-mono font-bold flex items-center justify-center shrink-0 border shadow-2xs"
                                    [ngClass]="getPlayerLineBadge(player.line).class"
                                  >
                                    {{ getPlayerLineBadge(player.line).code }}
                                  </span>

                                  @if (getPlayerRealClubCrestUrl(player); as crestUrl) {
                                    <div
                                      class="w-6 h-6 rounded-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center p-0.5 shrink-0 shadow-2xs"
                                      [title]="getPlayerRealClubName(player)"
                                    >
                                      <img
                                        [src]="crestUrl"
                                        [alt]="getPlayerRealClub(player)?.shortName || 'Club'"
                                        (error)="onCrestError($event)"
                                        referrerpolicy="no-referrer"
                                        class="w-full h-full object-contain"
                                      />
                                    </div>
                                  }

                                  <div class="min-w-0">
                                    <div class="flex items-center space-x-1.5">
                                      <span class="font-semibold text-slate-800 dark:text-slate-200 block truncate" [title]="getPlayerDisplayName(player)">
                                        {{ getPlayerDisplayName(player) }}
                                      </span>
                                      @if (getPlayerRealClub(player)?.shortName; as clubShort) {
                                        <span class="text-[10px] text-slate-400 dark:text-slate-500 font-mono shrink-0">
                                          {{ clubShort }}
                                        </span>
                                      }
                                    </div>
                                    <div class="flex items-center space-x-1.5 text-[10px]">
                                      <span
                                        class="px-1 py-0.2 rounded font-medium"
                                        [ngClass]="player.type === 'REAL' ? 'bg-blue-100 text-blue-700 dark:bg-blue-950/70 dark:text-blue-300' : 'bg-amber-100 text-amber-700 dark:bg-amber-950/70 dark:text-amber-300'"
                                      >
                                        {{ player.type }}
                                      </span>
                                      @if (player.status === 'PENDING') {
                                        <span class="text-slate-400 dark:text-slate-500 flex items-center space-x-0.5">
                                          <app-icon name="clock" [size]="10" />
                                          <span>Pendiente</span>
                                        </span>
                                      }
                                    </div>
                                  </div>
                                </div>

                                <!-- Player Points -->
                                <div class="shrink-0 text-right">
                                  @if (player.points !== null && player.points !== undefined) {
                                    <span
                                      class="inline-block px-2.5 py-1 rounded-lg font-mono font-bold text-xs shadow-2xs border"
                                      [ngClass]="player.points > 0 ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border-emerald-300 dark:border-emerald-800' : 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-200 dark:border-slate-700'"
                                    >
                                      {{ player.points }}
                                    </span>
                                  } @else {
                                    <span class="inline-flex items-center space-x-1 px-2 py-0.5 rounded-lg font-mono text-[11px] bg-slate-100 text-slate-400 dark:bg-slate-800 dark:text-slate-500 border border-slate-200/60 dark:border-slate-800">
                                      <app-icon name="clock" [size]="11" />
                                      <span>—</span>
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      } @empty {
                        <div class="py-6 text-center text-slate-400 text-xs">
                          No hay jugadores registrados en el acta de este club.
                        </div>
                      }
                    </div>

                    <!-- Banquillo Away -->
                    @if (matchLive()?.away?.bench && matchLive()!.away.bench!.length > 0) {
                      <div class="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800 space-y-2">
                        <div class="flex items-center justify-between text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          <span>Banquillo ({{ matchLive()!.away.bench!.length }})</span>
                        </div>
                        <div class="space-y-1">
                          @for (benchPlayer of matchLive()!.away.bench!; track benchPlayer.playerInstanceId) {
                            <div class="p-2 rounded-xl bg-slate-50 dark:bg-slate-950/40 border border-slate-200/60 dark:border-slate-800/60 flex items-center justify-between text-xs">
                              <div class="flex items-center space-x-2 min-w-0 pr-2">
                                <span class="w-6 h-5 rounded text-[10px] font-mono font-bold flex items-center justify-center shrink-0 border shadow-2xs bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-700">
                                  {{ benchPlayer.position || 'SUP' }}
                                </span>

                                @if (getPlayerRealClubCrestUrl(benchPlayer); as crestUrl) {
                                  <div
                                    class="w-6 h-6 rounded-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center p-0.5 shrink-0 shadow-2xs"
                                    [title]="getPlayerRealClubName(benchPlayer)"
                                  >
                                    <img
                                      [src]="crestUrl"
                                      [alt]="getPlayerRealClub(benchPlayer)?.shortName || 'Club'"
                                      (error)="onCrestError($event)"
                                      referrerpolicy="no-referrer"
                                      class="w-full h-full object-contain"
                                    />
                                  </div>
                                }

                                <div class="min-w-0">
                                  <div class="flex items-center space-x-1.5">
                                    <span class="font-semibold text-slate-800 dark:text-slate-200 block truncate">
                                      {{ benchPlayer.displayName || 'Suplente' }}
                                    </span>
                                    @if (getPlayerRealClub(benchPlayer)?.shortName; as clubShort) {
                                      <span class="text-[10px] text-slate-400 dark:text-slate-500 font-mono shrink-0">
                                        {{ clubShort }}
                                      </span>
                                    }
                                  </div>
                                  <div class="flex items-center space-x-1.5 text-[10px]">
                                    @if (benchPlayer.type) {
                                      <span class="px-1 py-0.2 rounded font-medium bg-slate-200/80 dark:bg-slate-800 text-slate-600 dark:text-slate-400">
                                        {{ benchPlayer.type }}
                                      </span>
                                    }
                                    @if (benchPlayer.retired) {
                                      <span class="px-1.5 py-0.2 rounded font-bold bg-rose-100 text-rose-700 dark:bg-rose-950/70 dark:text-rose-300">
                                        Retirado
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }

                    <!-- Historial de Sustituciones Away -->
                    @if (matchLive()?.away?.substitutionWindows && matchLive()!.away.substitutionWindows!.length > 0) {
                      <div class="mt-3 pt-3 border-t border-slate-100 dark:border-slate-800 space-y-2">
                        <div class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                          Historial de Sustituciones
                        </div>
                        <div class="space-y-1.5">
                          @for (win of matchLive()!.away.substitutionWindows!; track win.windowId || $index) {
                            <div class="p-2 rounded-xl bg-slate-50/70 dark:bg-slate-950/40 border border-slate-200/60 dark:border-slate-800/60 text-xs space-y-1">
                              <div class="flex items-center justify-between text-[10px] text-slate-500 font-medium">
                                <span>Ventana {{ win.ordinal }}</span>
                                <span class="font-mono text-slate-400">Rev. {{ win.revisionBefore }} ➔ {{ win.revisionAfter }}</span>
                              </div>
                              @for (ch of win.changes; track ch.outgoing + ch.incoming) {
                                <div class="flex items-center space-x-1 text-slate-700 dark:text-slate-300 text-[11px]">
                                  <span class="text-rose-600 dark:text-rose-400 font-medium">▼ {{ ch.outgoingName || ch.outgoing }}</span>
                                  <span class="text-slate-400">➔</span>
                                  <span class="text-emerald-600 dark:text-emerald-400 font-medium">▲ {{ ch.incomingName || ch.incoming }}</span>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          <!-- Scorers list if engineCalculation is available -->
          @if (inspectedFixture()!.engineCalculation?.goalScorers && inspectedFixture()!.engineCalculation.goalScorers.length > 0) {
            <div class="p-3.5 bg-slate-50 dark:bg-slate-950 rounded-2xl border border-slate-200 dark:border-slate-800">
              <h4 class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase mb-2">
                {{ game.t('comp.goalscorers') }}
              </h4>
              <div class="space-y-1 text-xs">
                @for (goal of inspectedFixture()!.engineCalculation.goalScorers; track $index) {
                  <div class="flex items-center justify-between text-slate-700 dark:text-slate-300">
                    <span>⚽ {{ goal.playerName }}</span>
                    <span class="font-mono text-slate-400 dark:text-slate-500">{{ goal.minute }}'</span>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Match economics & attendance if available from engine -->
          @if (inspectedFixture()!.engineCalculation?.attendanceCalculated) {
            <div class="grid grid-cols-2 gap-3 pt-1 text-xs">
              <div class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800">
                <div class="text-[10px] text-slate-500 dark:text-slate-400 uppercase font-semibold">
                  {{ game.t('comp.spectators') }}
                </div>
                <div class="font-bold text-slate-900 dark:text-white font-mono mt-1">
                  {{ inspectedFixture()!.engineCalculation.attendanceCalculated.toLocaleString() }}
                </div>
              </div>
              <div class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800">
                <div class="text-[10px] text-slate-500 dark:text-slate-400 uppercase font-semibold">
                  {{ game.t('comp.ticket_revenue') }}
                </div>
                <div class="font-bold text-emerald-600 dark:text-emerald-400 font-mono mt-1">
                  +{{ (inspectedFixture()!.engineCalculation.incomeTotal || 0).toLocaleString() }} €
                </div>
              </div>
            </div>
          }
        }
      </div>

        <!-- Modal Footer -->
        <div class="p-4 sm:p-5 border-t border-slate-100 dark:border-slate-800 flex items-center justify-end bg-slate-50/50 dark:bg-slate-950/50 shrink-0">
          <button
            type="button"
            (click)="closeInspectModal()"
            class="px-4 py-2 bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:hover:bg-white text-white dark:text-slate-900 text-xs font-bold rounded-xl cursor-pointer shadow-xs transition-colors"
          >
            {{ game.t('common.close') }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
